import React, { useEffect, useState } from "react";
import "./PaymentSuccessfulStyle.scss";
import greenTickIcon from "../../assets/images/greentickIcon.png";
import { useLocation, useNavigate } from "react-router-dom";
import UploadDocument from "../UploadDocument/UploadDocument";
import TopNavBar from "../TopNavBar/TopNavBar";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  getPolicyDetailsPersonalAccident,
  getPolicyDocuments,
} from "../../Redux/PersonalAccidentRedux";
import { getPolicyDetailsTermPlan } from "../../Redux/TermPlanRedux";
import {
  updateQuotesLife,
  uploadPolicyDocumentLife,
} from "../../Redux/LogsRedux/LifeQuotesRedux";
import { documentUpload } from "../../Redux/LoadingRedux";
import CustomModal from "../Common/CustomModal/CustomModal";
import { useTranslation } from "react-i18next";

function PaymentSuccessful() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [isSuccess, setIsSuccess] = useState(false);
  const [policyNumber, setPolicyNumber] = useState("");

  const [pdfUrl, setPdfUrl] = useState(null);
  const [policyScheduleUrl, setPolicyScheduleUrl] = useState(null);
  const [paymentReceiptUrl, setPaymentReceiptUrl] = useState(null);
  const [coverPlan, setCoverPlan] = useState("");
  const [encoded, setEncoded] = useState("");
  const [loading, setLoading] = useState(false);
  const [policyBlob, setPolicyBlob] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);

  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [fileName, setFileName] = useState("Policy Document");

  const handleSubmit = () => {
    localStorage.removeItem("LIFE_LEAD_ID");
    localStorage.removeItem("LIFE_QUOTE_ID");
    navigate("/");
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const policyNum = params.get("policyNumber"); // Extract quoteNumber
    const encodedPolicyNumber = encodeURIComponent(policyNum);
    setEncoded(encodedPolicyNumber);

    if (policyNum) {
      setPolicyNumber(decodeURIComponent(policyNum));
      dispatch(getPolicyDetailsTermPlan(encodedPolicyNumber)).then((result) => {
        if (result.success) {
          setCoverPlan(result?.data?.plan);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (!policyNumber) return;
    dispatch(documentUpload(false));
    dispatch(
      updateQuotesLife({
        paymentStatus: "PAID",
        quoteId: localStorage.getItem("LIFE_QUOTE_ID"),
        policyNo: policyNumber,
        quoteStatus:"UPDATED"
      }),
    );
    let url = null;
    setLoading(true);
    dispatch(getPolicyDocuments(encodeURIComponent(policyNumber))).then(
      (res) => {
        if (res?.success && res?.data) {
          if (typeof res.data === "string") {
          // legacy behavior: API returns base64 PDF
            const byteCharacters = atob(res.data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });

            setPolicyBlob(blob);

            url = URL.createObjectURL(blob);
            setPdfUrl(url);

            const formData = new FormData();
            formData.append(
              "policyDocumentLife",
              blob,
              `Policy_${policyNumber}.pdf`,
            );
            dispatch(
              uploadPolicyDocumentLife(
                formData,
                localStorage.getItem("LIFE_QUOTE_ID"),
              ),
            );
          } else if (typeof res.data === "object") {
            setPolicyScheduleUrl(res.data.policy_schedule_url || null);
            setPaymentReceiptUrl(res.data.payment_receipt_url || null);
            if (res.data.policy_schedule_url) {
              setPdfUrl(res.data.policy_schedule_url);
            }
          }
        }

        setLoading(false);
      },
    );

    return () => {
      if (url && url.startsWith("blob:")) {
        URL.revokeObjectURL(url);
      }
    };
  }, [isSuccess, policyNumber, dispatch]);

  const handlePreview = async (pdf, name) => {
    setFileName(name || "Policy Document");

    // If we received a direct PDF URL from the API, proxy it to avoid CORS.
    if (typeof pdf === "string" && (pdf.startsWith("http://") || pdf.startsWith("https://"))) {
      const proxyUrl = `${process.env.REACT_APP_API_URL}/proxy-pdf?url=${encodeURIComponent(pdf)}`;
      setSelectedPdf(proxyUrl);
      setIsSummaryOpen(true);
      return;
    }

    // If the API returned a blob URL or local object URL (legacy behavior)
    if (pdf) {
      setSelectedPdf(pdf);
      setIsSummaryOpen(true);
      return;
    }

  // if no pdf URL, fallback to blob from legacy base64 conversion
    if (policyBlob) {
      const previewUrl = URL.createObjectURL(policyBlob);
      setSelectedPdf(previewUrl);
      setIsSummaryOpen(true);
    }
  };

  const handleDownload = (downloadUrl, name) => {
    if (!downloadUrl) return;

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.target = "_blank";
    link.download = name || `Policy_${policyNumber}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {/* <TopNavBar /> */}
      <div className="container-fluid bg-white py-4">
        <div className="d-flex justify-content-center">
          <div className="col-12 col-md-10 col-lg-5">
            <div className="text-center">
              <img
                src={greenTickIcon}
                alt="greentickicon"
                className="img-fluid mx-auto success-animate"
                style={{ width: "80px" }}
              />

              <h5 className="mt-3 mb-1 payment-success-label">
                {t("Your premium payment is successful.")}
              </h5>
              <p className="fw-bold mb-3 payment-success-label">
                {t("Thank you")}!
              </p>
            </div>

            <div
              className="card shadow-sm rounded-4 p-4"
              style={{ width: "100%", maxWidth: "520px", margin: "0 auto" }}
            >
              <h5 className="fw-semibold mb-4 text-center">
                {t("Policy Details")}
              </h5>

              <div className="row mb-2">
                <div className="col-5 text-muted">{t("Policy No")}</div>
                <div className="col-7 text-end fw-medium">{policyNumber}</div>
              </div>
            </div>
            <>
              <div style={{ marginTop: 20, marginBottom: 20 }}>
                {policyScheduleUrl || paymentReceiptUrl ? (
                  <div
                    style={{
                      width: "100%",
                      maxWidth: "520px",
                      margin: "0 auto",
                    }}
                  >
                    <table className="table table-borderless mb-0 ">
                      <tbody>
                        {policyScheduleUrl && (
                          <tr>
                            <td className="fw-semibold">
                              {t("Policy Schedule Document")}
                            </td>
                            <td
                              className={`d-flex gap-2 ${i18n.language === "ar" ? "justify-content-center" : "justify-content-end"}`}
                            >
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm me-2"
                                onClick={() => handlePreview(policyScheduleUrl, t("Policy Schedule Document"))}
                                disabled={!policyScheduleUrl}
                              >
                                {t("Preview")}
                              </button>
                              <button
                                onClick={() => handleDownload(policyScheduleUrl, `Policy_${policyNumber}.pdf`)}
                                disabled={!policyScheduleUrl}
                                className="btn btn-primary btn-sm"
                              >
                                {t("Download")}
                              </button>
                            </td>
                          </tr>
                        )}
                        {paymentReceiptUrl && (
                          <tr>
                            <td className="fw-semibold">
                              {t("Payment Receipt")}
                            </td>
                            <td
                              className={`d-flex gap-2 ${i18n.language === "ar" ? "justify-content-center" : "justify-content-end"}`}
                            >
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm me-2"
                                onClick={() => handlePreview(paymentReceiptUrl, t("Payment Receipt"))}
                                disabled={!paymentReceiptUrl}
                              >
                                {t("Preview")}
                              </button>
                              <button
                                onClick={() => handleDownload(paymentReceiptUrl, `Receipt_${policyNumber}.pdf`)}
                                disabled={!paymentReceiptUrl}
                                className="btn btn-primary btn-sm"
                              >
                                {t("Download")}
                              </button>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : pdfUrl ? (
                  <>
                    <div
                      style={{
                        width: "100%",
                        maxWidth: "520px",
                        margin: "0 auto",
                      }}
                    >
                      <table className="table table-borderless mb-0 ">
                        <tbody>
                          <tr>
                            <td className="fw-semibold">
                              {t("Policy Document")}
                            </td>
                            <td
                              className={`d-flex gap-2 ${i18n.language === "ar" ? "justify-content-center" : "justify-content-end"}`}
                            >
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm me-2"
                                  onClick={() => handlePreview(pdfUrl, t("Policy Document"))}
                                disabled={!pdfUrl}
                              >
                                {t("Preview")}
                              </button>
                              <button
                                  onClick={() => handleDownload(pdfUrl)}
                                disabled={!pdfUrl}
                                className="btn btn-primary btn-sm"
                              >
                                {t("Download")}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : loading ? (
                  <div className="d-flex justify-content-center gap-2">
                    <div className="loader-sm"></div>

                    <p className="fw-semibold mb-0">
                      {t("Please wait your document is loading...")}
                    </p>
                  </div>
                ) : null}
              </div>

              <div className="d-flex justify-content-center align-item-center">
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="btn btn-primary fw-bold mb-3 rounded-5 "
                >
                  {t("Go back home")}
                </button>
              </div>
            </>
            <p className="acknowledge-para small text-muted ">
              {t(
                "Your policy has been sent to you via WhatsApp and email according",
              )}
              {t("to your communication preferences.")} <br />
              {t(
                "Additionally, an SMS link has been provided for you to download",
              )}
              {t("your policy document.")}
            </p>
          </div>
        </div>
        <CustomModal
          isOpen={isSummaryOpen}
          onClose={() => {
            setIsSummaryOpen(false);
            if (selectedPdf) {
              URL.revokeObjectURL(selectedPdf);
              setSelectedPdf(null);
            }
          }}
          title={fileName}
          download={true}
          pdfUrl={selectedPdf}
        >
          <div
            className="modal-body"
            style={{ overflow: "hidden", padding: 0, height: "70vh" }}
          >
            {selectedPdf && (
              <iframe
                title="View Document"
                src={`${selectedPdf}#page=1&toolbar=0`}
                width="100%"
                height="95%"
                style={{ border: "none" }}
              />
            )}
          </div>
        </CustomModal>
      </div>
    </>
  );
}

export default PaymentSuccessful;
